var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"flex-row-reverse":"","disabled":_vm.isDisabled,"loading":_vm.loading,"icon":""},on:{"click":function($event){return _vm.confirmTerminate()}}},[_c('v-icon',[_vm._v("\n    mdi-download-box-outline\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }